import InteractionData from './InteractionData'

export default InteractionData
